// import { Modal, Select } from 'antd';
// import { FC, useEffect, useState } from 'react';
// import { AddButton } from '../../../../lib/components/Buttons/AddButton';
// import { InputItem } from '../../../../lib/components/InputItem';
// import { InsertTagDto } from '../../../../lib/dtos/TagDto';
// import { useRequestFeedback } from '../../../../lib/hooks';
// import { ContractTagsType, useTagsManagementApi } from '../hooks/ContractTagsApi';
// import { request } from '../../../../lib/utils/request';
// import { PermissionDto } from '../../../../lib/dtos/PermissionDto';
// import { UpdateButton } from '../../../../lib/components/Buttons/UpdateButton';

// interface IProps {
// 	type: ContractTagsType;
// 	visible: boolean;
// 	current_update_id?: any;
// 	close: () => void;
// 	insert_success: () => void;
// }

// const PERMISSIONS_BASE_URL = `${process.env.REACT_APP_PERMISSIONS_GROUPS_API}/permissions`;

// export const TagInsertModal: FC<IProps> = ({ type, visible, current_update_id, close, insert_success }) => {
// 	const [id, set_id] = useState(current_update_id?.id || '');
// 	const [title, set_title] = useState(current_update_id?.title || '');
// 	const [permission_options, set_permission_options] = useState<any[]>([]);
// 	const [permission_group, set_permission_group] = useState<any>(current_update_id?.permission_id || '');

// 	const { insert } = useTagsManagementApi(type);

// 	useEffect(() => {
// 		if (!visible) return;
// 		loadPermissions();
// 	}, [visible]);

// 	const loadPermissions = async () => {
// 		const r = await request().get<PermissionDto[]>(PERMISSIONS_BASE_URL);
// 		set_permission_options(r);
// 	};

// 	useEffect(() => {
// 		if (!!insert.result) {
// 			insert_success();
// 			close();
// 		}
// 	}, [insert.result]);

// 	useEffect(() => {
// 		set_id(current_update_id?.id || '');
// 		set_title(current_update_id?.title || '');
// 		set_permission_group(current_update_id?.permission_id || '');
// 	}, [current_update_id]);

// 	const submit = () => {
// 		const dto: InsertTagDto = { title: title };
// 		if (permission_group) {
// 			dto.permission_id = permission_group;
// 		}
// 		if (title) insert.create(dto);
// 	};

// 	useRequestFeedback(insert.result, insert.error);

// 	return (
// 		<Modal
// 			{...{
// 				title: 'Criar Série',
// 				visible,
// 				closable: true,
// 				onCancel: close,
// 				destroyOnClose: true,
// 				centered: true,
// 				footer: [
// 					current_update_id?.id ? (
// 						<UpdateButton {...{ onClick: submit, disabled: !title || !permission_group }} />
// 					) : (
// 						<AddButton {...{ onClick: submit, disabled: !title || !permission_group }} />
// 					),
// 				],
// 			}}
// 		>
// 			<InputItem
// 				{...{
// 					label: 'Título',
// 					input_item_name: title,
// 					on_changed: set_title,
// 					disabled: !!current_update_id?.title,
// 				}}
// 			/>
// 			<div className='mt-2'>
// 				<label className='mr-4 font-semibold'>
// 					<span className='text-red-500'> * </span>
// 					Grupo de Permissão:
// 				</label>
// 				<div className='w-5/6'>
// 					<Select
// 						placeholder='Selecione'
// 						onChange={(v) => set_permission_group(v)}
// 						style={{ width: '100%' }}
// 						value={permission_group}
// 					>
// 						<Select.Option value=''>{''}</Select.Option>
// 						{permission_options.map((o) => (
// 							<Select.Option value={String(o.id)} key={`group-${o.id}`}>
// 								{o.title}
// 							</Select.Option>
// 						))}
// 					</Select>
// 				</div>
// 			</div>
// 		</Modal>
// 	);
// };

import { Modal, Select, Radio } from 'antd';
import { FC, useEffect, useState } from 'react';
import { AddButton } from '../../../../lib/components/Buttons/AddButton';
import { InputItem } from '../../../../lib/components/InputItem';
import { InsertTagDto } from '../../../../lib/dtos/TagDto';
import { useRequestFeedback } from '../../../../lib/hooks';
import { ContractTagsType, useTagsManagementApi } from '../hooks/ContractTagsApi';
import { request } from '../../../../lib/utils/request';
import { PermissionDto } from '../../../../lib/dtos/PermissionDto';
import { UpdateButton } from '../../../../lib/components/Buttons/UpdateButton';

interface IProps {
	type: ContractTagsType;
	visible: boolean;
	current_update_id?: any;
	close: () => void;
	insert_success: () => void;
}

const PERMISSIONS_BASE_URL = `${process.env.REACT_APP_PERMISSIONS_GROUPS_API}/permissions`;

export const TagInsertModal: FC<IProps> = ({ type, visible, current_update_id, close, insert_success }) => {
	const [id, set_id] = useState(current_update_id?.id || '');
	const [title, set_title] = useState(current_update_id?.title || '');
	const [permission_options, set_permission_options] = useState<PermissionDto[]>([]);
	const [permission_group, set_permission_group] = useState<string>(
		String(current_update_id?.permission_id || '')
	);
	const [loading, set_loading] = useState(false);

	// novo estado para o Radio.Group
	const [forum_signature, set_forum_signature] = useState<boolean | null>(
		current_update_id?.forum_signature ?? false
	);

	const { insert } = useTagsManagementApi(type);

	useEffect(() => {
		if (!visible) return;
		loadPermissions();
	}, [visible]);

	const loadPermissions = async () => {
		set_loading(true);
		try {
			const r = await request().get<PermissionDto[]>(PERMISSIONS_BASE_URL);
			set_permission_options(r);
		} finally {
			set_loading(false);
		}
	};

	useEffect(() => {
		if (!!insert.result) {
			insert_success();
			close();
		}
	}, [insert.result]);

	useEffect(() => {
		set_id(current_update_id?.id || '');
		set_title(current_update_id?.title || '');
		set_permission_group(String(current_update_id?.permission_id || ''));
		set_forum_signature(current_update_id?.forum_signature ?? false);
	}, [current_update_id]);

	const submit = () => {
		const dto: InsertTagDto = {
			title,
			permission_id: permission_group || undefined,
			forum_signature: forum_signature || false,
		};

		// adiciona somente se o usuário escolheu
		if (forum_signature !== null) {
			dto.forum_signature = forum_signature;
		}
		console.log(dto.forum_signature, ' : dto.forum_signature');
		if (title) insert.create(dto);
	};

	useRequestFeedback(insert.result, insert.error);

	return (
		<Modal
			{...{
				title: current_update_id?.id ? 'Atualizar Série' : 'Criar Série',
				visible,
				closable: true,
				onCancel: close,
				destroyOnClose: true,
				centered: true,
				footer: [
					current_update_id?.id ? (
						<UpdateButton
							{...{
								onClick: submit,
								disabled: !title || !permission_group || forum_signature === null,
							}}
						/>
					) : (
						<AddButton
							{...{
								onClick: submit,
								disabled: !title || !permission_group || forum_signature === null,
							}}
						/>
					),
				],
			}}
		>
			<InputItem
				{...{
					label: 'Título',
					input_item_name: title,
					on_changed: set_title,
					disabled: !!current_update_id?.title,
				}}
			/>

			{/* Grupo de permissão */}
			<div className='mt-2'>
				<label className='mr-4 font-semibold'>
					<span className='text-red-500'> * </span>
					Grupo de Permissão:
				</label>
				<div className='w-5/6'>
					<Select
						placeholder='Selecione'
						onChange={(v) => set_permission_group(v)}
						style={{ width: '100%' }}
						value={permission_group}
						loading={loading}
					>
						<Select.Option value=''>Selecione um grupo</Select.Option>
						{permission_options.map((o) => (
							<Select.Option value={String(o.id)} key={`group-${o.id}`}>
								{o.title}
							</Select.Option>
						))}
					</Select>
				</div>
			</div>

			{/* RadioGroup - Fórum Assinatura */}
			<div className='mt-4'>
				<label className='mr-4 font-semibold'>
					<span className='text-red-500'> * </span>A série pertence a FÓRUM Assinatura?
				</label>
				<Radio.Group onChange={(e) => set_forum_signature(e.target.value)} value={forum_signature}>
					<Radio value={true}>Sim</Radio>
					<Radio value={false}>Não</Radio>
				</Radio.Group>
			</div>
		</Modal>
	);
};
